var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.2 6.6l-3.3 3.3 1.8 8.9c.1.3 0 .7-.3.9l-.7.7c-.5.5-1.4.3-1.6-.3l-2.6-6.7-3.4 3.4.2 2.2c0 .3-.1.6-.3.8l-1.1 1.1-2.1-3.5-3.5-2.1 1-1.3c.2-.2.5-.3.8-.3l2.2.2 3.4-3.4-6.8-2.6c-.6-.3-.8-1.1-.3-1.6l.7-.7c.2-.2.6-.3.9-.3l8.9 1.8 3.3-3.3c.8-.8 2-.8 2.8 0v0c.8.8.8 2 0 2.8v0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgAirplane;